<script setup lang="ts">
import { dateRange } from '~/helpers/formatDateRange.js'

const { pageType, trackEvent } = useTracking()
const { locale, t } = useI18n()

const { lastSearches = [] } = defineProps<{
  lastSearches: LastSearchItem[]
}>()
const emits = defineEmits<{ 'last-search-clicked': [] }>()

const { goToSearch, setData } = useSearchInput()

const handleLastSearch = (item: LastSearchItem) => {
  setData('location', {
    type: 'destination',
    ...item,
  })
  trackEvent({
    event: 'previous_search_click',
    source: pageType.value,
  })
  if (item.startDate && item.endDate) {
    setData('endDate', item.endDate)
    setData('startDate', item.startDate)
  } else {
    setData('endDate', null)
    setData('startDate', null)
  }
  setData('guest', item.guest || 0)
  goToSearch()

  emits('last-search-clicked')
}

const dateRangeFormatted = ({ startDate, endDate }: LastSearchItem) => {
  return dateRange({
    i18n: { locale, t },
    startDate,
    endDate,
  })
}
</script>

<template>
  <div class="mb-2 last:mb-0">
    <div class="mb-2 text-left text-xs font-bold md:px-1">
      {{ t('search.lastSearch') }}
    </div>
    <ul class="mb-0 grid grid-cols-2 gap-x-4 laptop:grid-cols-1">
      <li
        v-for="item in lastSearches"
        :key="item.id"
        class="flex cursor-pointer items-center py-2 text-left text-md hover:bg-beige md:px-1"
        @click.stop="handleLastSearch(item)"
      >
        <BaseIcon name="search" class="mr-4 flex-none" />
        <div class="truncate">
          <span>
            {{ item.name }}
          </span>
          <div
            v-if="item.startDate && item.endDate"
            class="truncate text-sm text-gray-500"
          >
            {{ dateRangeFormatted(item) }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
